// extracted by mini-css-extract-plugin
module.exports = {"navbarDesc":"LicenseHistory_navbarDesc__1w2Ds","resultsCount":"LicenseHistory_resultsCount__2gf0_","linkInactive":"LicenseHistory_linkInactive__2URL4"};